import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import ElementPlus from "element-plus";
import { ElMessage, ElButton, ElInput } from "element-plus";
import "element-plus/dist/index.css";
import { vClickOutside } from "@/directives/clickOutside";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { vValidateCharset } from "@/directives/validateCharset";
import "@/styles/global.css";
import { handleUrlToken } from "@/utils/tokenHandler";

// import driver from './plugins/driver'; // 引入 driver 插件

const app = createApp(App);
const pinia = createPinia();

// 你可以在这里将 driver 实例挂载到全局属性中
// app.config.globalProperties.$driver = driver;

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(router);
app.use(ElementPlus);
app.use(vClickOutside);
app.use(pinia);
app.directive("validate-charset", vValidateCharset);

// 处理URL中的token参数
handleUrlToken();

// 监听postMessage消息，支持跨域token设置
window.addEventListener('message', (event) => {
  // 验证消息来源（可以根据需要调整）
  // if (event.origin !== 'http://localhost:5174') return;
  
  if (event.data && event.data.type === 'SET_TOKEN') {
    localStorage.setItem('token', event.data.token);
    console.log('通过postMessage设置token:', event.data.token);
    
    // 如果当前在登录页，自动跳转到主页
    if (window.location.pathname === '/login') {
      router.push('/standard');
    }
  }
});

// 校验非法字符的正则
const INVALID_CHAR_REGEX = /[\p{C}]/gu;

// 处理非法字符校验逻辑
const validateInput = (target: HTMLInputElement | HTMLTextAreaElement) => {
  const rawValue = target.value;
  const cleanedValue = rawValue.replace(INVALID_CHAR_REGEX, ""); // 清理非法字符
  if (cleanedValue !== rawValue) {
    // 提示用户输入非法字符
    ElMessage.warning("输入包含无效字符（如控制符）！");
    // 更新输入框内容
    target.value = cleanedValue;
    // 手动触发 Vue v-model 数据同步
    target.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

// 全局监听输入事件
document.addEventListener("input", (event) => {
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
    // 判断是否为 Element Plus 的输入框
    const isElInput = target.closest(".el-input__inner");
    if (!isElInput) return;

    // 跳过中文输入法组合状态
    const isComposing = (target as any).__isComposing;
    if (isComposing) return;

    // 验证输入内容
    validateInput(target);
  }
});

// 监听中文输入法组合事件
document.addEventListener("compositionstart", (event) => {
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
    (target as any).__isComposing = true; // 标记组合开始
  }
});

document.addEventListener("compositionend", (event) => {
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
    (target as any).__isComposing = false; // 标记组合结束
    // 结束组合后重新校验输入
    validateInput(target);
  }
});
app.mount("#app");
